"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _empty = _interopRequireDefault(require("../empty"));

var _ = require(".");

var renderEmpty = function renderEmpty(componentName) {
  return (
    /*#__PURE__*/
    React.createElement(_.ConfigConsumer, null, function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var prefix = getPrefixCls('empty');

      switch (componentName) {
        case 'Table':
        case 'List':
          return (
            /*#__PURE__*/
            React.createElement(_empty["default"], {
              image: _empty["default"].PRESENTED_IMAGE_SIMPLE
            })
          );

        case 'Select':
        case 'TreeSelect':
        case 'Cascader':
        case 'Transfer':
        case 'Mentions':
          return (
            /*#__PURE__*/
            React.createElement(_empty["default"], {
              image: _empty["default"].PRESENTED_IMAGE_SIMPLE,
              className: "".concat(prefix, "-small")
            })
          );

        default:
          return (
            /*#__PURE__*/
            React.createElement(_empty["default"], null)
          );
      }
    })
  );
};

var _default = renderEmpty;
exports["default"] = _default;